import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, first, map, switchMap } from 'rxjs/operators';
import { FinancialListService } from '../financial-list.service';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-financial-category',
  templateUrl: './financial-category.component.html',
  styleUrls: ['./financial-category.component.scss']
})
export class FinancialCategoryComponent implements OnInit {
  category: string;
  incomeList;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private financialListService: FinancialListService,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.route.params.pipe(
      first(),
      switchMap(params => {
        this.category = params['category'];
        // // console.log(params['category']);
        switch (this.category) {
          case 'workshop': {
            this.gobalFunctionService.setTitle('รายการทางการเงิน Workshop');
            return this.financialListService.getWorkshop(this.category);
          }
          case 'course': {
            this.gobalFunctionService.setTitle('รายการทางการเงิน Course');
            return this.financialListService.getCourse(this.category);
          }
          case 'measure': {
            this.gobalFunctionService.setTitle('รายการทางการเงิน Measure');
            return this.financialListService.getMeasure(this.category);
          }
        }
      }),
      map(res => {
        this.incomeList = res.result;
        // // console.log(this.incomeList);
      }),
      catchError((err) => {
        alert(err);
        return of(false)
      })
    ).subscribe();
  }
}
